import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    createRes: null,
    getAllRes: null,
    getByIdRes: null,
    updateRes: null,
    removeRes: null,
    getStatusRes: null,
    updateTestMappingRes: null,
    getLogsRes: null,
    connectRes: null,
    disconnectRes: null,
    serialPortsRes: null,
};

const slice = createSlice({
    name: 'labAnalyzer',
    initialState,
    reducers: {
        createLabAnalyzerRequest: (state) => { state.loading = true; },
        createLabAnalyzerSuccess: (state, action) => { state.loading = false; state.createRes = action.payload; },
        createLabAnalyzerFailure: (state, action) => { state.loading = false; state.createRes = action.payload; },
        resetCreateLabAnalyzer: (state) => { state.createRes = null; },

        getAllLabAnalyzerRequest: (state) => { state.loading = true; },
        getAllLabAnalyzerSuccess: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        getAllLabAnalyzerFailure: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        resetGetAllLabAnalyzer: (state) => { state.getAllRes = null; },

        getByIdLabAnalyzerRequest: (state) => { state.loading = true; },
        getByIdLabAnalyzerSuccess: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        getByIdLabAnalyzerFailure: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        resetGetByIdLabAnalyzer: (state) => { state.getByIdRes = null; },

        updateLabAnalyzerRequest: (state) => { state.loading = true; },
        updateLabAnalyzerSuccess: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        updateLabAnalyzerFailure: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        resetUpdateLabAnalyzer: (state) => { state.updateRes = null; },

        removeLabAnalyzerRequest: (state) => { state.loading = true; },
        removeLabAnalyzerSuccess: (state, action) => { state.loading = false; state.removeRes = action.payload; },
        removeLabAnalyzerFailure: (state, action) => { state.loading = false; state.removeRes = action.payload; },
        resetRemoveLabAnalyzer: (state) => { state.removeRes = null; },

        getLabAnalyzerStatusRequest: (state) => { state.loading = true; },
        getLabAnalyzerStatusSuccess: (state, action) => { state.loading = false; state.getStatusRes = action.payload; },
        getLabAnalyzerStatusFailure: (state, action) => { state.loading = false; state.getStatusRes = action.payload; },
        resetGetLabAnalyzerStatus: (state) => { state.getStatusRes = null; },

        updateLabAnalyzerTestMappingRequest: (state) => { state.loading = true; },
        updateLabAnalyzerTestMappingSuccess: (state, action) => { state.loading = false; state.updateTestMappingRes = action.payload; },
        updateLabAnalyzerTestMappingFailure: (state, action) => { state.loading = false; state.updateTestMappingRes = action.payload; },
        resetUpdateLabAnalyzerTestMapping: (state) => { state.updateTestMappingRes = null; },

        getLabAnalyzerLogsRequest: (state) => { state.loading = true; },
        getLabAnalyzerLogsSuccess: (state, action) => { state.loading = false; state.getLogsRes = action.payload; },
        getLabAnalyzerLogsFailure: (state, action) => { state.loading = false; state.getLogsRes = action.payload; },
        resetGetLabAnalyzerLogs: (state) => { state.getLogsRes = null; },

        connectLabAnalyzerRequest: (state) => { state.loading = true; },
        connectLabAnalyzerSuccess: (state, action) => { state.loading = false; state.connectRes = action.payload; },
        connectLabAnalyzerFailure: (state, action) => { state.loading = false; state.connectRes = action.payload; },
        resetConnectLabAnalyzer: (state) => { state.connectRes = null; },

        disconnectLabAnalyzerRequest: (state) => { state.loading = true; },
        disconnectLabAnalyzerSuccess: (state, action) => { state.loading = false; state.disconnectRes = action.payload; },
        disconnectLabAnalyzerFailure: (state, action) => { state.loading = false; state.disconnectRes = action.payload; },
        resetDisconnectLabAnalyzer: (state) => { state.disconnectRes = null; },

        getSerialPortsRequest: (state) => { state.loading = true; },
        getSerialPortsSuccess: (state, action) => { state.loading = false; state.serialPortsRes = action.payload; },
        getSerialPortsFailure: (state, action) => { state.loading = false; state.serialPortsRes = action.payload; },
        resetGetSerialPorts: (state) => { state.serialPortsRes = null; },
    }
});

export const {
    createLabAnalyzerRequest, createLabAnalyzerSuccess, createLabAnalyzerFailure, resetCreateLabAnalyzer,
    getAllLabAnalyzerRequest, getAllLabAnalyzerSuccess, getAllLabAnalyzerFailure, resetGetAllLabAnalyzer,
    getByIdLabAnalyzerRequest, getByIdLabAnalyzerSuccess, getByIdLabAnalyzerFailure, resetGetByIdLabAnalyzer,
    updateLabAnalyzerRequest, updateLabAnalyzerSuccess, updateLabAnalyzerFailure, resetUpdateLabAnalyzer,
    removeLabAnalyzerRequest, removeLabAnalyzerSuccess, removeLabAnalyzerFailure, resetRemoveLabAnalyzer,
    getLabAnalyzerStatusRequest, getLabAnalyzerStatusSuccess, getLabAnalyzerStatusFailure, resetGetLabAnalyzerStatus,
    updateLabAnalyzerTestMappingRequest, updateLabAnalyzerTestMappingSuccess, updateLabAnalyzerTestMappingFailure, resetUpdateLabAnalyzerTestMapping,
    getLabAnalyzerLogsRequest, getLabAnalyzerLogsSuccess, getLabAnalyzerLogsFailure, resetGetLabAnalyzerLogs,
    connectLabAnalyzerRequest, connectLabAnalyzerSuccess, connectLabAnalyzerFailure, resetConnectLabAnalyzer,
    disconnectLabAnalyzerRequest, disconnectLabAnalyzerSuccess, disconnectLabAnalyzerFailure, resetDisconnectLabAnalyzer,
    getSerialPortsRequest, getSerialPortsSuccess, getSerialPortsFailure, resetGetSerialPorts,
} = slice.actions;

export default slice.reducer;
